import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Avatar,
  Breadcrumb,
  Button,
  Checkbox,
  Form,
  Input,
  Layout,
  List,
  message,
  Radio,
  Table,
} from 'antd';
import { SearchOutlined, FormOutlined, ShopOutlined } from '@ant-design/icons';
import _ from 'lodash';

import './styles.module.scss';
import { API_HOST } from 'configs/env';
import whttp from 'libs/whttp';
import DeleteConfirmButton from 'components/DeleteConfirmButton/DeleteConfirmButton';

const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 };

export default class CatalogueList extends Component {
  formRef = React.createRef();

  state = {
    tableInfo: {
      current: 0,
      page_size: 10,
      total: 0,
      rows: [],
    },
    message: '',
    categoryCheckboxList: [],
    isLoadingData: false,
  };

  componentDidMount() {
    this.getCatalogueList(this.formRef.current.getFieldsValue());
    this.getCategoryCheckboxList();
  }

  getCatalogueList = (values, opt = { page: 1, page_size: 10 }) => {
    const { page, page_size } = opt;
    this.setState({ isLoadingData: true });
    whttp.get(
      `${API_HOST}/api/mgt/v1/catalogues`,
      {
        keyword: values.keyword,
        category_ids: values.category_ids,
        promotion_status: values.promotion_status,
        page: page,
        page_size: page_size,
      },
      (state, res) => {
        this.setState({ isLoadingData: false });
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return this.setState({ message: '發生錯誤' });
        }
        if (code !== 200) {
          return this.setState({ message: reason });
        }
        this.setState({ tableInfo: data });
      }
    );
  };

  handleSearch = (values) => {
    console.log('search values', values);
    this.getCatalogueList(values);
  };

  handleReset = () => {
    this.formRef.current.resetFields();
    this.getCatalogueList(this.formRef.current.getFieldsValue());
  };

  getCategoryCheckboxList = () => {
    whttp.get(
      `${API_HOST}/api/mgt/v1/categories`,
      { type: 4 },
      (state, res) => {
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return this.setState({ message: '發生錯誤' });
        }
        if (code !== 200) {
          return this.setState({ message: reason });
        }
        this.setState({ categoryCheckboxList: data.rows });
      }
    );
  };

  deleteData = (item) => {
    if (_.isNil(item.id)) return;
    item.isDeleteData = true;
    this.setState({ isDeleteData: true });
    whttp.delete(
      `${API_HOST}/api/mgt/v1/catalogues/${item.id}`,
      {},
      (state, res) => {
        item.isDeleteData = false;
        this.setState({ isDeleteData: false });
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return message.error('發生錯誤');
        }
        if (code !== 200) {
          return message.error(reason);
        }
        message.success('刪除成功');
        this.getCatalogueList(this.formRef.current.getFieldsValue());
      }
    );
  };

  render() {
    const { tableInfo, categoryCheckboxList } = this.state;

    return (
      <Layout>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to={`/catalogues`}>促銷目錄管理</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
        <h2>促銷目錄管理</h2>
        <div className='block search'>
          <Form
            ref={this.formRef}
            className='basicForm'
            initialValues={{
              keyword: '',
              category_ids: [],
              promotion_status: 1,
            }}
            layout='vertical'
            autoComplete='off'
            onFinish={this.handleSearch}
          >
            <div className='flexBox col_12'>
              <Form.Item name='keyword' label='名稱'>
                <Input placeholder='搜尋名稱' />
              </Form.Item>
            </div>
            <Form.Item name='category_ids' label='目錄類別'>
              <Checkbox.Group>
                <List
                  grid={listGrid}
                  dataSource={categoryCheckboxList}
                  renderItem={(item) => (
                    <List.Item>
                      <Checkbox value={item.id}>{item.name}</Checkbox>
                    </List.Item>
                  )}
                />
              </Checkbox.Group>
            </Form.Item>
            <Form.Item name='promotion_status' label='目錄狀態'>
              <Radio.Group>
                <Radio.Button value={1}>全部</Radio.Button>
                <Radio.Button value={2}>上架中</Radio.Button>
                <Radio.Button value={3}>準備中</Radio.Button>
                <Radio.Button value={4}>已下架</Radio.Button>
              </Radio.Group>
            </Form.Item>
            <Form.Item style={{ marginTop: '50px' }}>
              <Button onClick={this.handleReset}>重置</Button>
              <Button
                type='primary'
                style={{ marginLeft: 8 }}
                icon={<SearchOutlined />}
                htmlType='submit'
              >
                搜尋
              </Button>
            </Form.Item>
          </Form>
        </div>
        <div className='toolbar'>
          <h3>
            促銷目錄列表
            <span />
          </h3>
          <Form layout='inline'>
            <Form.Item>
              <div className='flexBox'>
                <Link to={`/catalogues/view`}>
                  <Button type='primary'>新增</Button>
                </Link>
              </div>
            </Form.Item>
          </Form>
        </div>
        <Table
          dataSource={tableInfo.rows}
          loading={this.state.isLoadingData}
          pagination={{
            current: _.get(tableInfo, 'current', []),
            total: _.get(tableInfo, 'total', 0),
            pageSize: _.get(tableInfo, 'page_size', 0),
            onChange: (page, page_size) => {
              this.getCatalogueList(this.formRef.current.getFieldsValue(), {
                page: page,
                page_size: page_size,
              });
            },
          }}
          columns={[
            { dataIndex: 'id', title: 'ID' },
            {
              dataIndex: ['images', '0', 'url'],
              title: '封面',
              render: (image) => (
                <Avatar shape='square' icon={<ShopOutlined />} src={image} />
              ),
            },
            { dataIndex: 'name', title: '名稱' },
            { dataIndex: 'category_name', title: '分類' },
            { dataIndex: 'status_name', title: '狀態' },
            { dataIndex: 'sort', title: '排序' },
            { dataIndex: 'modified_at', title: '更新時間' },
            { dataIndex: ['modified_user', 'name'], title: '異動者' },
            {
              title: 'Action',
              key: 'tools',
              width: 250,
              render: (text, record) => (
                <List
                  grid={{ gutter: 4, column: 3 }}
                  dataSource={[
                    <DeleteConfirmButton
                      loading={record.isDeleteData === true}
                      size='small'
                      onConfirm={() => this.deleteData(record)}
                    />,
                    <Link role='button' to={`/catalogues/view/${record.id}`}>
                      <Button
                        type='default'
                        size='small'
                        icon={<FormOutlined />}
                      >
                        編輯
                      </Button>
                    </Link>,
                  ]}
                  renderItem={(item) => <List.Item>{item}</List.Item>}
                />
              ),
            },
          ]}
        />
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Catalogue/CatalogueList.js